var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.644,
    height: 20,
    viewBox: "0 0 16.644 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Password",
    d: "M16.018,19.993H2.7a1.665,1.665,0,0,1-1.664-1.667V9.993A1.666,1.666,0,0,1,2.7,8.326h.832v-2.5a5.826,5.826,0,1,1,11.652,0v2.5h.832a1.665,1.665,0,0,1,1.664,1.667v8.334A1.666,1.666,0,0,1,16.018,19.993ZM12.689,5.827a3.329,3.329,0,1,0-6.658,0v2.5h6.658Z",
    transform: "translate(-1.038 0.007)",
    fill: "#8fa2bb",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.505822851b9b6f38a5189dabd0b235fb.svg";
export { ForwardRef as ReactComponent };